module.exports = __webpack_public_path__ + "static/media/1010001BE.575d564c.jpg";